import { render, staticRenderFns } from "./dashboardTab.vue?vue&type=template&id=356fc2dd&scoped=true"
import script from "./dashboardTab.vue?vue&type=script&lang=js"
export * from "./dashboardTab.vue?vue&type=script&lang=js"
import style0 from "./dashboardTab.vue?vue&type=style&index=0&id=356fc2dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356fc2dd",
  null
  
)

export default component.exports